// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__RU7Gy","inputWrap":"Table_inputWrap__2mTMo","col":"Table_col__1okJf","bmiTooltip":"Table_bmiTooltip__bXHVV"};